/* @flow */

module.exports = {
  "LOCALE": {
    "ISO": {
      "639-1": "da",
      "3166-1": "DK",
      "IETF": "da-DK",
    },
    "CURRENCY": "DKK",
    "CURRENCY_SHORT": "kr",
    "TYPEKIT_ID": "thm8nca",
    "POINTS": "",
  },
  "SKIP_TO_CONTENT": "Gå til indhold",
  "CLOSE": "Tæt",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "LOGO": {
    "ALT": "Zupergift.com",
    "TITLE": "Hjem",
  },
  "CLOSE_SYSTEM_MESSAGE": "Luk besked",
  "COOKIE_CONSENT": {
    "TEXT": "Zupergift bruger cookies til at forbedre din oplevelse på dette website. Når du går videre på websitet, accepterer du vores brug af cookies. Læs vores <a href=\"/dk/faq\">integritetspolitik</a>, hvis du ønsker yderligere oplysninger om cookies, og om hvordan du kan fravælge cookies.",
    "ALL": "Tillad alle ",
    "SELECTED": "Tillad valg",
    "NECESSARY": "Kun nødvendige",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "ROUTES": {
    "ALL_GIFTCARDS": "/alle-gavekort",
  },
  "HOMEVIEW": {
    "HERO_ALT": "Zupergift.com",
    "REDEEM_CTA": "Indløs din Zupergift",
    "EXPLORE_CTA": "Udforsk gavekort",
    "EXPLORE_LINK": "/alle-gavekort",
    "ZUPERGIFT_CTA": "Køb Zupergift",
    "ZUPERGIFT_LINK": "/zupergift",
    "POPULAR_BRANDS": "Populære brands",
    "POPULAR_CATEGORIES": "Populære kategorier",
    "POPULAR_PRODUCTS": "Populære gavekort",
    "SEE_MORE": "Se mere",
    "ALL_CATEGORIES": "Alle kategorier",
    "MORE_POPULAR_PRODUCTS": "Flere populære produkter",
    "BECOME_CUSTOMER": "Bliv kunde",
    "TUTORIAL": "Sådan fungerer det",
  },
  "COMPANYVIEW": {
    "CTA_1": "Tilbudsanmodning",
    "CTA_LINK_1": "https://2dd4ic.share-eu1.hsforms.com/2wBFM1jZjTIaiurEOi1TAJA",
    "FIELD_1": {
      "TITLE": "Firmagaver",
      "TEXT_CONTENT": "At give en gave i form af et gavekort er en enkel, men stærk måde at vise værdsættelse på. Belønninger og anerkendelse styrker relationer, øger loyaliteten og kan bidrage til større motivation og engagement. En velplaceret gestus med mange positive effekter!",
    },
    "FIELD_2": {
      "TITLE": "Passer til alle anledninger",
      "TEXT_CONTENT": "Zupergift er den perfekte gave til mange forskellige lejligheder – både store og små. Til medarbejdere er den ideel som påskønnelse ved fødselsdage, jubilæer, jul, sommergave eller som en uventet tak for en god indsats. Kunder kan belønnes efter afsluttede samarbejder, ved reklamationer som kompensation eller som en måde at styrke loyaliteten og opbygge relationer. Også forretningspartnere sætter pris på en gennemtænkt gave, især i forbindelse med milepæle, højtider eller som tak efter vellykkede projekter. Med Zupergift får modtageren friheden til selv at vælge sin gave – hvilket gør gestussen både personlig og værdsat.",
    },
    "FIELD_3": {
      "TITLE": "Vores udvalg",
      "TEXT_CONTENT": "Med Zupergift får modtageren adgang til over 100 kendte brands og kan selv vælge den gave, der passer bedst. Modtageren kan handle hos populære butikker og tjenester som Zalando, Tivoli, Rituals, CDON, Vero Moda, SAS og mange flere. Perfekt til virksomheder, der vil være sikre på at give en gave, som alle sætter pris på.",
    },
  },
  "TUTORIAL": {
    "STEP_1": {
      "TITLE": "1",
      "LINK_END": "her",
      "TEXT": "Køb Zupergift ",
      "LINK": "/zupergift",
    },
    "STEP_2": {
      "TITLE": "2",
      "TEXT": "Levering direkte på e-mail",
    },
    "STEP_3": {
      "TITLE": "3",
      "LINK_END": "her",
      "TEXT": "Indløs Zupergift ",
      "LINK": "/redeem",
    },
    "STEP_4": {
      "TITLE": "4",
      "LINK_END": "her",
      "TEXT": "Vælg gavekort",
      "LINK": "/alle-gavekort",
    },
  },
  "LOGIN": {
    "TITLE": "Log ind som kunde",
    "EMAIL": "Din e-mailadresse",
    "CUSTOMER_NUMBER": "Kundenummer, du vil logge ind med",
    "PASSWORD": "Adgangskode",
  },
  "REDEEM": {
    "HEADING": "Indløs dit gavekort",
    "CLOSE": "Luk",
    "TEXT": "Start med at indtaste din kode nedenfor. Du finder koden i e-mailen, der indeholder dit Zupergift-gavekort. I det næste trin vælger du, hvilket eller hvilke brands du vil indløse dit gavekort til. Derefter går du til kassen, også lander dit valg af gavekort i din e-mail. Zuper enkelt!",
    "PLACEHOLDER_CODE": "Indtast kode",
    "PLACEHOLDER_PIN": "Indtast PIN-kod",
    "SUBMIT": "Spara",
    "SUCCESS_ROUTE": "/alle-gavekort",
  },
  "ACCOUNT": {
    "LOGIN": "Log ind",
    "LOGOUT": "Log ud",
    "MY_ACCOUNT": "Min konto",
    "USER": "Bruger",
    "SHIPPING_ADDRESS": "Leveringsadresse",
    "WISHLIST": "Ønskeliste",
    "EMAIL": "E-mail",
    "BALANCE": "Saldo",
    "DATE": "Dato",
    "SEE_ALL": "Se alle",
    "EDIT": "Ændre",
    "YOUR_BALANCE": "Din saldo er %amount",
  },
  "WISHLIST": {
    "TITLE": "Ønskeliste",
    "BACK": "Gå til min konto",
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Efternavn",
    "STREET_1": "Adresse 1",
    "STREET_2": "Adresse 2 (valgfri)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "OR": "eller",
  "VALUE": "Værdi",
  "CART": {
    "DISTRIBUTION": "Betalingsfordeling",
    "CLOSE": "Luk kurven",
    "HEADING": "Indkøbskurv",
    "TOTALS": "Totalt",
    "YOUR_BALANCE": "Din saldo",
    "AFTER_PURCHASE": "Saldo efter køb",
    "VALID_TO": "Gyldig indtil",
    "PAY_CASH": "Kort/faktura",
    "PAY_VOUCHER": "Gavekort",
    "EMPTY": "Indkøbskurven er tom",
    "INCREMENT": "Øg antal",
    "DECREMENT": "Reducere antal",
    "QUANTITY": "Antal",
    "CTA": "Gå til indkøbskurven",
    "PRODUCTS": "Produkter",
    "SHIPPING": "Fragt",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå til kassen",
    "MOVE_TO_WISHLIST": "Flyt til ønskeliste",
    "DIALOG_CANCEL": "Luk",
    "REMOVE_PRODUCT": "Fjern produkt",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra indkøbskurven?",
    "CONTINUE_SHOPPING": "Fortsæt med at handle",
    "DISCOUNT": "Rabat",
    "SUB_TOTAL": "Beløb",
    "SUB_TOTAL_WITH_DISCOUNT": "Subtotal eksklusiv rabat",
    "GRAND_TOTAL": "Total",
    "CLOSE_SUMMARY": "Luk oversigten",
    "OPEN_SUMMARY": "Åbn oversigten",
    "SUBMIT": "Gem antal produkter",
  },
  "CHECKOUT": {
    "TITLE": "Kasse",
    "CART": "Din indkøbskurv indeholder ",
    "CONTINUE": "Forsæt",
    "CUSTOMER_INFORMATION": "Kundeoplysninger",
    "REDEEM_NOTICE": "Nu er det tid til at gennemføre købet og indtaste koden på dit Zupergift gavekort.",
    "DELIVERY_NOTICE": "Når du har godkendt og indløst din Zupergift, sendes de valgte gavekort til den e-mail-adresse, du har angivet.",
    "CONTACT_CUSTOMER_SERVICE": "Kontakt kundeseervice",
    "PLACE_ORDER": "Godkend og indløs",
    "TO_PAYMENT": "Gå til betaling",
    "EMAIL": "E-mail",
    "EMAIL_REPEAT": "Gentag e-mail",
    "TELEPHONE": "Mobilnummer",
    "AMOUNT_TO_PAY": "At betale",
    "PAY_WITH_CARD": "Betal med kort",
    "EDIT": "Ændre",
    "DELIVERY": "Levering",
    "SENT_TO": "Sendes til",
    "CONTINUE_SHOPPING": "Forsæt med at handle",
    "BACK_TO_CART_TEXT": "Tilbage til indkøbskurven",
    "COMPLETE_PURCHASE": "Afslut køb",
    "CARD_PAYMENT": "Kortbetaling",
    "REDEEM_LABEL_CODE": "Gavekortkode",
    "REDEEM_LABEL_PIN": "Indtast tilhørende pinkode",
    "REDEEM_SUBMIT": "Brugt",
    "REDEEM_AMOUNT": "Din Zupergift indeholder i totalt %value.",
    "REDEEM_ERROR_INSUFFICIENT": "Du har %value på dit Zupergift-gavekort. Nedenfor kan du se, hvilke gavekort du har i din indkøbskurv, og hvor meget du har tilbage på dit Zupergift-gavekort efter købet. ",
    "REDEEM_BUTTON_LABEL": "Jeg har en Zupergiftkode",
    "OPT_EMAIL": "Jeg vil gerne have information om tilbud fra Zupergift",
    "I_ACCEPT_THE": "Jeg accepterer",
    "TERMS": "købsbetingelserne",
    "TERMS_URL": "handelsbetingelser",
    "PAYMENT_METHOD_STEP": "Vælg betalingsmetode",
    "PAY_STEP": "Gå til sikker betaling",
    "ADDRESS": {
      "ADDRESS": "Faktura- og leveringsoplysninger",
      "SHIPPING": "Leveringsadresse",
      "BILLING": "Faktura adresse",
      "SHIP_TO_SAME_ADDRESS": "Leveret til samme adresse",
      "CONTACT_INFO": "Kontaktoplysninger",
    },
    "DISCOUNT_CODE": {
      "HEADER": "Rabatkode",
      "PLACEHOLDER": "Indtast kode",
      "APPLY": "Anvend",
      "REMOVE": "Fjerne",
    },
  },
  "PAYMENT": {
    "TITLE": "Hvordan vil du betale?",
    "USE_PAY": "Betal nu",
    "USE_CARD": "Betal med kort",
  },
  "PAYMENT_METHODS": {
    "APPLE_PAY": "pay",
    "ALTAPAY": {
      "CARD": "Betal med kort",
    },
  },
  "PAYMENT_LIMIT": {
    "TEXT_ONE": "Det er i øjeblikket ikke muligt at handle for mere end %amount.",
    "TEXT_TWO": "Kontakt venligst kundeservice for mere information på <a href=\"mailto:info@awardit.com\">info@awardit.com</a>.",
  },
  "SUCCESS": {
    "TITLE": "Ordre registreret",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Forsæt med at handle",
    "NOT_FOUND_TITLE": "Ingen ordre fundet.",
    "NOT_FOUND_SUBTITLE": "Kontakt kundeservice, hvis dette er forkert.",
    "WHAT_NOW": "Så hvad sker der nu?",
    "STEPS": {
      "HEADING": "Ordre registreret",
      "WHAT_NOW": "Så hvad sker der nu?",
      "LABEL": "Din ordre",
      "ORDER_ID": "Ordrenummer %id",
      "QUESTIONS": {
        "HEADING": "Har du et spørgsmål om din ordre?",
        "LABEL": "Gå til kundtservice",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse vil  blive sendt til %email.",
        },
        "2": {
          "HEADING": "Behandler",
          "TEXT": "Din ordre sendes, når alle produkter er tilgængelige for levering. Dette sker som regel den næste dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er pakket og sendt, får du besked via e-mail. I leveringsbekræftelsen finder du et sporingslink, så du kan følge pakken. Leveringen tager normalt 1-2 dage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Nogle pakker leveres direkte til din postkasse. Pakker, der er for store, leveres i stedet til et leveringssted og du meddeles via SMS til det mobilnummer, du har angivet i ordren. Pakker ligger på leveringsstedet i 14 dage.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "En ordrebekræftelse og dine digitale billetter/værdikoder vil snart blive sendt til %email. Hvis du ikke har modtaget nogen e-mail, kontrollere venligst dit spamfilter, før du kontakter kundeservice.",
        },
        "2": {
          "HEADING": "Behandler",
          "TEXT": "Din ordre sendes, når alle produkter er tilgængelige for levering. Dette sker som regel den næste dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når dine varer er pakket og sendt, får du besked via e-mail. I leveringsbekræftelsen finder du et sporingslink, så du kan følge pakken. Leveringen tager normalt 1-2 dage.",
        },
        "4": {
          "HEADING": "Levering",
          "TEXT": "Vi sender dine digitale billetter/værdikoder til %email. Din fysiske levering sendes med DBSchenker. Nogle pakker leveres direkte til din postkasse. Pakker, der er for store, leveres i stedet til et leveringssted og du meddeles via SMS til det mobilnummer, du har angivet i ordren. Pakker ligger på leveringsstedet i 14 dage.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekræftelse",
          "TEXT": "Du modtager en ordrebekræftelse til %email",
        },
        "2": {
          "HEADING": "Digital levering",
          "TEXT": "Vi sender dine digitale billetter/værdikoder til %email. Hvis du ikke har modtaget nogen e-mail, kontrollere venligst dit spamfilter, før du kontakter kundeservice.",
        },
      },
    },
    "CONTACT": {
      "HEADING": "Har du nogle spørgsmål?",
      "TEXT": "Vi besvarer dine spørgsmål vedrørende levering, produkter eller sortimentet inden for 48 timer på hverdage.",
      "LINK": "https://helpdesk.crossroads.se/?s=1600988e7224b21600988e7224e9",
      "LINK_TEXT": "Skriv til os via vores kontaktformular",
    },
  },
  "OLD_BROWSER": {
    "INFO": "Hej! Du bruger en forældet browser. <a href=\"http://outdatedbrowser.com\" rel=\"noopener\" target=\"blank\"> opdater din browser </a> for at bruge zupergift.com",
  },
  "CATEGORY": {
    "EMPTY": "Der er ingen produkter at vise lige nu",
    "LOAD_MORE": "Indlæs mere",
    "PRODUCTS_IN_CATEGORY_TITLE": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
  },
  "ALL_GIFTCARDS": {
    "TITLE": "Alla gavekort",
  },
  "404": {
    "TITLE": "Siden kunne ikke findes",
    "HEADING": "— 404 —",
    "SUBHEADING": "Siden kunne ikke findes",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfejl",
    "HEADING": "Serverfejl: 500",
    "SUBHEADING": "Kom snart tilbage!",
    "TEXT": "<strong> Har du brug for at kontakte os? </strong> <br/> Send en e-mail til <a href=\"mailto:kundservice@crossroads.se\"> kundservice@crossroads.se </a>",
  },
  "SLIDER": {
    "SLIDE": "Slide %number",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søg: ",
    "PLACEHOLDER": "Søg efter et gavekort",
    "SEARCH_RESULT": "Fundet 1 matchende produkt",
    "PRODUCTS_IN_SEARCH_RESULT": "Fundet %itemsCount matchende produkter",
    "PRODUCT_IN_SEARCH_RESULT": "Fundet en matchende produkt",
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alla filtre",
      "FILTER_BY_POINTS": "Filtrer på point",
      "FILTER_BY_PRICE": "Filtrer på pris",
      "PRICE_RANGE": "%min - %max kr",
      "SORT": "Sortere",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Navn ↓",
      "SORT_NAME_ASC": "Navn  ↑",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Vis resultat",
      "CLOSE_MENU": "Luk filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Ryd filtre",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filtree",
      "PRICE_RANGE": "Pris (%range)",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrer på point",
      "FILTER_BY_POINTS": "Filtrer på pris",
      "RESET_PRICE": "Ryd filtre",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
    },
  },
  "HEADER": {
    "OPEN_MENU": "Åbn menuen",
    "CLOSE_MENU": "Luk menu",
    "BACK": "Gå tilbage",
    "SEARCH": "Søg",
    "OPEN_SEARCH": "Åbn søgning",
    "CLOSE_SEARCH": "Luk søgning",
    "ALL_GIFTCARDS": "Alle gavekort",
    "BUY_ZUPERGIFT": "Køb Zupergift",
    "REDEEM_GIFTCARD": "Indløs din Zupergift",
    "CATEGORIES": "Kategorier",
    "COMPANY": "Forretning",
    "CART": "Indkøbskurv",
    "HELP": "Kontakt",
    "ABOUT": "Hvordan fungerer det?",
    "CLOSE_CATEGORIES": "Lik kategorier",
    "BRANDS": "Brands",
    "CLOSE_BRANDS": "Luk brands",
    "ACCOUNT": "Min konto",
    "CUSTOMER_SERVICE": "Kundeservice",
  },
  "FOOTER": {
    "CURRENT_LANG": "Du besøger Zupergift på dansk.",
    "CHANGE_LANG": "Skifte sprog",
    "CATEGORIES": "Kategorier",
    "COPYRIGHT": "Copyright © %currentYear",
    "RECAPTCHA": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\">Terms of Service</a> apply.",
    "LANGUAGE_SWITCHER_TEXT": "You're using the Danish version of Zupergift",
    "LANGUAGE_SWITCHER_BUTTON": "Change language/region",
    "COOKIES": "Administrer cookies",
    "TERMS_LINK": "handelsbetingelser",
    "TERMS_TEXT": "Handelsbetingelser",
    "ACCESSIBILITY": "Tilgængelighed",
  },
  "LANGUAGE_SWITCHER": {
    "TITLE": "Welcome!",
    "CLOSE": "Close language switcher",
    "SUB_TITLE": "You're using the Danish version of Zupergift. Do you want to change language/region?",
    "FINLAND": "Finland",
    "DENMARK": "Denmark",
    "NORWAY": "Norway",
    "SWEDEN": "Sweden",
  },
  "BREADCRUMBS": {
    "HOME": "Hjem",
    "HOME_URL": "/",
    "SEARCH": "Søgeresultater for \"%query\"",
    "SEARCH_RESULTS_FOR": "Søgeresultater for: ",
  },
  "PRODUCT": {
    "STARTING_AT": "Fra",
    "ADD_TO_CART": "Læg i indkøbskurv",
    "OUT_OF_STOCK": "Udsolgt",
    "TOO_LOW_BALANCE": "For lav saldo",
    "DESCRIPTION": "Produktbeskrivelse",
    "OTHERS_ALSO_LIKED": "Andre kan også lide",
    "OPTION_PLACEHOLDER": "Vælg %attributeLabel",
    "LOGIN_TO_PURCHASE": "Log ind for at kunne handle",
    "CHANGE_IMAGE": "BSkift billede",
    "OPTION_DROPDOWN_PLACEHOLDER": "Vælg et alternativ ...",
  },
  "VALIDATION": {
    "REQUIRED": "Dette felt er obligatorisk.",
    "EMAIL": "Indtast en gyldig e-mailadresse.",
    "PHONE": "Indtast venligst et gyldigt mobilnummer.",
    "NUMERIC": "Feltet kan kun indeholde tal.",
    "LENGTH_LT": "Feltet indeholder for mange tegn.",
    "POSTCODE": "Indtast venligst et korrekt postnummer. (XXX XX)",
    "MATCH": "Feltet matcher ikke.",
    "PHONE_LENGTH_COLLECTOR": "Mobilnummeret er for kort.",
    "MISSING_FIELD": "Manglende adresse. Prøv igen",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "Der er opstået en ukendt fejl. Genindlæs siden, og prøv igen.",
    "NETWORK_ERROR": "Signalet blev afbrudt. Kontroller, at du har en aktiv internetforbindelse eller prøv igen om et øjeblik.",
    "PLACE_ORDER_CATCH": "En fejl opstod. Prøv igen senere.",
    "AQUIRER_DECLINE": "Betalingen er blevet afvist. Bekræft venligst dine kort-/kontooplysninger.",

    "COLLECTOR": {
      "SESSION_EXPIRED": "Sessionen med Collector er afsluttet. Genindlæs siden.",
      "NUM_TRIES_EXCEEDED": "Kan ikke hente ordren. Kontakt venligst kundeservice.",
    },

    "errorProductQuantityNotAvailable": "Det antal du har indtastet, er ikke tilgængelig i øjeblikket.",
    "errorProductNotInStock": "Det produkt du forsøger at tilføje til kurven, er desværre ikke på lager i øjeblikket.",
    "errorProductMaxQuantity": "Det angivne antal er desværre ikke på lager i øjeblikket.",
    "errorProductNotChosenVariant": "Vælg %attributeLabel for at kunne tilføje produkter til din indkøbskurv.",
    "termsNotAccepted": "Du skal acceptere købsbetingelserne for at gennemføre dit køb.",
    "errorBillingAddressValidationFailed": "Forkert adresse",
    "REDEEM_ERROR": {
      "_777": "Gavekortskoden er ikke gyldig. Kontrollere koden, og prøv igen.",
      "_786": "Ukendt kodevalideringsfejl. Kontroller koden, og prøv igen.",
      "_791": "Gavekortskoden kræver en PIN-kode. Indtast den tilknyttede pinkode, og prøv igen.",
      "_792": "PIN-koden er ikke gyldig. Kontroller pinkoden, og prøv igen.",
    },
    "success": "Gavekortskode aktiveret!",
    "DISCOUNT_CODE_FAILURE": "Rabatkoden kunne ikke anvendes, prøv venligst igen eller kontakt kundeservice.",
    "DISCOUNT_CODE_APPLIED": "Rabatkode anvendt.",
  },
  "ICONS": {
    "ARROW": "Pil højre",
    "CART": "Indkøbskurv",
    "HEADPHONES": "Hovedtelefoner",
    "MAGNIFIER": "Forstørrelsesglas",
    "CROSS": "Kryds",
    "HAMBURGER": "Tre vandrette linjer (hamburgerikon)",
    "AVATAR": "Avatar",
    "DENMARK_FLAG": "Danmarks flag",
    "FINLAND_FLAG": "Finlands flag",
    "SWEDEN_FLAG": "Sveriges flag",
    "NORWAY_FLAG": "Norges flag",
  },
};
